import {
    addFollow,
    FollowCard,
    withFollow,
} from '@eventbrite/follow-organizer-ebui';
import { gettext } from '@eventbrite/i18n';
import { Location } from 'history';
import React from 'react';
import { formatUrl } from 'url-lib';
import { UserShape } from '../../../../types';
import { CategoryBrowseBucket } from '../../components/CategoryBrowseBucket';
import { HEAP_PAGE_AREA } from '../../constants/heap';
import { useBaseEventsQueryEvents } from '../../hooks/queries/events';
import { useOrganizersInEvents } from '../../hooks/queries/organizers';
import './CategoryBrowseOrganizers.scss';

interface GaSettings {
    isActive: boolean;
    userPartnerId: string | null;
    guestPartnerId: string | null;
    correlationId: string | null;
    activeScopeUserId: string | null;
}

const EnhancedFollowCard = withFollow(FollowCard);

const OrganizerList = addFollow(
    ({
        organizers,
        children,
    }: {
        organizers: string[];
        children: React.ReactChildren;
    }) => {
        const organizerCards = organizers.map((organizerId) => (
            <li
                key={organizerId}
                className="category-browse__organizer-follow--list-item"
            >
                <EnhancedFollowCard
                    gaCategory="category-page"
                    style="grid"
                    size="standard"
                    organizerId={organizerId}
                    shouldHideDefaultDataPoint={true}
                />
            </li>
        ));

        return (
            <ul className="category-browse__organizer-follow">
                {organizerCards}
                {children}
            </ul>
        );
    },
);

interface CategoryBrowseOrganizersProps {
    user: UserShape;
    location: Location;
    gaSettings: GaSettings;
}

export const CategoryBrowseOrganizers: React.FunctionComponent<
    CategoryBrowseOrganizersProps
> = (props) => {
    const { data: organizers } = useOrganizersInEvents();
    const { data } = useBaseEventsQueryEvents({
        optOutDedupeEvents: true,
    });
    const baseEvents = data?.events || [];

    if (!baseEvents || !organizers) {
        //return stub with height
        return <section style={{ minHeight: '250px' }}></section>;
    }

    //No events to pull from
    if (baseEvents.length === 0) {
        return null;
    }

    const organizerIds = organizers?.map(({ id }) => id);

    return (
        <CategoryBrowseBucket title={gettext('Organizers to follow')}>
            <section style={{ minHeight: '250px' }}>
                <OrganizerList
                    organizers={organizerIds}
                    gaSettings={props.gaSettings}
                    gaCategory="category-page"
                    userId={props.user?.publicId}
                    isAuthenticated={props.user?.isAuthenticated}
                    isGDPRCountry={true}
                    loginOptions={{
                        referrer: formatUrl(
                            `${props.location.pathname}${props.location.search}`,
                        ),
                    }}
                    pageArea={HEAP_PAGE_AREA}
                />
            </section>
        </CategoryBrowseBucket>
    );
};
